import { lazy } from 'react';

// Dashboard
export const Dashboard = lazy(() => import('../pages/dashboard/Dashboard'));

// Distributor
export const Distributor = lazy(() => import('../pages/distributor/Distributor'));
export const DistributorForm = lazy(() => import('../pages/distributor/DistributorForm'));
export const DistributorView = lazy(() => import('../pages/distributor/DistributorView'));
export const DistributorOrder = lazy(() => import('../pages/distributor/DistributorOrder'));

// Payment
export const Payment = lazy(() => import('../pages/distributor/Payment'));

// Policies
export const Policies = lazy(() => import('../pages/distributor/Policies'));
export const PolicyForm = lazy(() => import('../pages/policies/PolicyForm'));

// Promo
export const Promo = lazy(() => import('../pages/promo/Promo'));

// New Version
export const NewVersion = lazy(() => import('../pages/newVersion/NewVersion'));
export const AppUpdate = lazy(() => import('../pages/appUpdate/AppUpdate'));

// Profile
export const Profile = lazy(() => import('../pages/profile/pofile'));

// Server
export const Server = lazy(() => import('../pages/server/Server'));
export const ServerMonitoring = lazy(() => import('../pages/serverMonitoring/ServerMonitoring'));

// Service Type
export const ServiceType = lazy(() => import('../pages/serviceType/ServiceType'));
export const Tickets = lazy(() => import('../pages/tickets/Tickets'));
export const Quote = lazy(() => import('../pages/quote/Quote'));
export const Lead = lazy(() => import('../pages/lead/Lead'));
export const Blog = lazy(() => import('../pages/blog/Blog'));

// Auth Pages
export const Login = lazy(() => import('../pages/auth/LoginPage'));
export const LoginOtp = lazy(() => import('../pages/auth/LoginOtp'));
export const OTPVerification = lazy(() => import('../pages/auth/OTPVerification'));
export const ForgotPassword = lazy(() => import('../pages/auth/ForgotPassword'));
export const ResetPasswordPage = lazy(() => import('../pages/auth/ResetPasswordPage'));

// Other Pages
export const ExampleForm = lazy(() => import('../pages/example/ExampleForm')); 